import React, { useState } from "react";
import { Button, Field, Form } from "@bwevents/components";
import "./ForgotPassword.scss";
import { Link } from "react-router-dom";

export default function ForgotPassword({ api }) {
  const [email, setEmail] = useState();
  const [submitted, setSubmitted] = useState(false);

  const formValid = email;

  const handleForgotPassword = () => {
    api("api/auth/forgot/", {
      method: "POST",
      body: {
        email: email,
      },
    })
      .then(({ ok }) => {
        if (ok) {
          setSubmitted(true);
        }
      })
      .finally(() => {
        setEmail(null);
      });
  };

  return (
    <div className="forgot-password">
      <div className="bw-event-container">
        <h2>Password recovery</h2>
        <p>
          Please enter the email address associated with your account, we will
          send a password reset to the email on file.
        </p>
        <Form>
          <Field
            type="text"
            label="Email"
            placeholder="Email"
            value={email}
            setValue={setEmail}
            className="bw-event-input"
          />
          <div className="wrapper-btns">
            <Link to="/login" className="bw-event-btn cancel">
              Cancel
            </Link>
            <Button
              className="bw-event-btn"
              label="Continue"
              onClick={handleForgotPassword}
              disabled={!formValid}
            />
          </div>
        </Form>
        {submitted ? (
          <p>
            Still no email with new password from us? Check spam folder,{" "}
            <Link to="/forgot-password">resend password</Link> or{" "}
            <Link to="/contact-us">contact us</Link>
          </p>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
